var _rect, _g, _defs;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgExploreAppIllustration(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 96,
    height: 96,
    viewBox: "0 0 96 96",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 96,
    height: 96,
    rx: 4,
    fill: "#F2F2FF"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#exploreAppIllustration_svg__clip0_2325_132674)",
    fill: "#4B3ED5"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M44.719 32.688h-9.844c-1.208 0-2.188.979-2.188 2.187v12.031h14.22V34.875c0-1.208-.98-2.188-2.188-2.188zM34.875 30.5a4.375 4.375 0 00-4.375 4.375v14.219h18.594V34.875a4.375 4.375 0 00-4.375-4.375h-9.844z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.466 41.913a3.458 3.458 0 010-4.89l5.5-5.5a3.458 3.458 0 014.89 0l5.501 5.5a3.457 3.457 0 010 4.89l-5.5 5.5a3.458 3.458 0 01-4.89 0l-5.501-5.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M55.2 32.738l-5.508 5.507a1.73 1.73 0 000 2.447L55.2 46.2a1.731 1.731 0 002.447 0l5.507-5.508a1.73 1.73 0 000-2.447l-5.507-5.507a1.731 1.731 0 00-2.447 0zm-6.731 4.283a3.461 3.461 0 000 4.895l5.507 5.507a3.462 3.462 0 004.895 0l5.507-5.507a3.461 3.461 0 000-4.895l-5.507-5.507a3.462 3.462 0 00-4.895 0l-5.507 5.507zM34.875 63.313h12.031v-14.22H32.688v12.032c0 1.208.979 2.188 2.187 2.188zM49.094 65.5V46.906H30.5v14.219a4.375 4.375 0 004.375 4.375h14.219z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M61.125 63.313H49.094v-14.22h14.218v12.032c0 1.208-.979 2.188-2.187 2.188zM46.906 65.5V46.906H65.5v14.219a4.375 4.375 0 01-4.375 4.375H46.906z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "exploreAppIllustration_svg__clip0_2325_132674"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(30.5 30.5)",
    d: "M0 0h35v35H0z"
  })))));
}

export default __webpack_public_path__ + "static/media/exploreAppIllustration.48a8ca3d.svg";
export { SvgExploreAppIllustration as ReactComponent };